export const HARDCODED_ROOT_ID = 'HARDCODED_ROOT_ID';
